<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card style="background: #e0e0e0;">
          <v-card-text>
            <LoaderApi ref="loaderApi" apiUrl="portal/service-desk/well">
              <template slot-scope="{ data: wells }">
                <v-app-bar flat dense color="#C5C5C5" class="my-5" v-if="wells && wells.wells">
                  <v-toolbar-title v-if="wells.wells.length === 1">
                    <span>{{ wells.wells.length }} Poço</span>
                  </v-toolbar-title>
                  <v-toolbar-title v-else>
                    <span>{{ wells.wells.length }} Poços</span>
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  
                  <!-- Toggle de visão -->
                  <div class="view-toggle-container">
                    <v-btn-toggle 
                      v-model="viewMode" 
                      mandatory 
                      class="view-toggle"
                      color="primary"
                    >
                      <v-btn value="list" class="view-btn">
                        <v-icon size="20">view_list</v-icon>
                        <span class="view-btn-text">Lista</span>
                      </v-btn>
                      <v-btn value="map" class="view-btn">
                        <v-icon size="20">map</v-icon>
                        <span class="view-btn-text">Mapa</span>
                      </v-btn>
                    </v-btn-toggle>
                  </div>
                </v-app-bar>
                
                <!-- Conteúdo principal baseado na visão selecionada -->
                <div v-if="wells && wells.wells && wells.wells.length > 0">
                  <!-- Visão Lista -->
                  <div v-if="viewMode === 'list'" class="timeline-container">
                    <div 
                      v-for="(cityGroup, cityKey) in groupWellsByCity(wells.wells)" 
                      :key="cityKey"
                      class="timeline-city-group"
                    >
                      <!-- Timeline Label -->
                      <div class="timeline-label">
                        <div class="timeline-label-content">
                          <div class="timeline-label-icon">
                            <v-icon color="white" size="18">location_city</v-icon>
                          </div>
                          <div class="timeline-label-text">
                            <h3 class="timeline-city-name">{{ cityGroup.cityName }}</h3>
                            <p class="timeline-state">{{ cityGroup.state }}</p>
                          </div>
                          <div class="timeline-label-count">
                            <v-chip 
                              color="white" 
                              small 
                              class="timeline-count-chip"
                            >
                              {{ cityGroup.wells.length }} {{ cityGroup.wells.length === 1 ? 'poço' : 'poços' }}
                            </v-chip>
                          </div>
                        </div>
                        <div class="timeline-line"></div>
                      </div>

                      <!-- Wells da cidade -->
                      <div class="timeline-wells">
                        <v-row>
                          <WellCard 
                            v-for="well in cityGroup.wells" 
                            :key="well.id"
                            :well="well"
                            @show-detail="showDetail"
                          />
                        </v-row>
                      </div>
                    </div>
                  </div>

                  <!-- Visão Mapa -->
                  <div v-else-if="viewMode === 'map'" class="map-container">
                    <div id="wells-map" class="wells-map"></div>
                    <!-- Inicializar mapa quando os dados estiverem disponíveis -->
                    <div v-if="wells && wells.wells" style="display: none;">
                      {{ initializeMapWithData(wells.wells) }}
                    </div>
                  </div>
                </div>

                <!-- Estado vazio quando não há poços -->
                <div v-else-if="wells && wells.wells && wells.wells.length === 0" class="empty-state">
                  <v-container class="text-center py-12">
                    <v-icon size="80" color="grey lighten-2" class="mb-4">water_drop</v-icon>
                    <h2 class="text-h5 grey--text mb-3">Nenhum poço encontrado</h2>
                    <p class="text-body-1 grey--text mb-6">
                      Não há poços disponíveis no momento.<br>
                      Os poços aparecerão aqui quando forem cadastrados.
                    </p>
                  <v-btn 
                    color="primary" 
                    outlined 
                    @click="refreshWells"
                  >
                    <v-icon left>refresh</v-icon>
                    Atualizar
                  </v-btn>
                  </v-container>
                </div>

                <!-- Estado de carregamento -->
                <div v-else-if="!wells" class="loading-state">
                  <v-container class="text-center py-12">
                    <v-progress-circular
                      indeterminate
                      color="primary"
                      size="64"
                      class="mb-4"
                    ></v-progress-circular>
                    <h3 class="text-h6 grey--text">Carregando poços...</h3>
                  </v-container>
                </div>
              </template>
            </LoaderApi>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import LoaderApi from "@/default/components/LoaderApi/LoaderApi";
import WellCard from "./WellCard.vue";

export default {
  name: "Wells",

  data: () => ({
    form: {},
    viewMode: 'list', // 'list' ou 'map'
  }),
  
  methods: {
    showDetail: function(well) {
      // Navegar para a página de detalhes do poço
      this.$router.push({ 
        name: 'well', 
        params: { id: well.uuid } 
      });
    },


    refreshWells: function() {
      // Método para atualizar a lista de poços
      // O LoaderApi irá recarregar automaticamente
      this.$forceUpdate();
    },

    // Inicializar o mapa quando os dados estiverem disponíveis
    initializeMapWithData: function(wells) {
      if (this.viewMode === 'map' && wells && wells.length > 0) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.initializeMap(wells);
          }, 100);
        });
      }
      return '';
    },

    // Inicializar o mapa do Google
    initializeMap: function(wells) {
      this.$nextTick(() => {
        const mapElement = document.getElementById('wells-map');
        
        if (!mapElement || !wells || wells.length === 0) {
          return;
        }

        // Verificar se o Google Maps está carregado
        // eslint-disable-next-line no-undef
        if (typeof google === 'undefined' || !google.maps) {
          setTimeout(() => {
            this.initializeMap(wells);
          }, 1000);
          return;
        }

        // Calcular centro do mapa baseado nos poços
        // eslint-disable-next-line no-undef
        const bounds = new google.maps.LatLngBounds();
        const markers = [];

        wells.forEach((well, index) => {
          if (well.address && well.address.latitude && well.address.longitude) {
            const position = {
              lat: parseFloat(well.address.latitude),
              lng: parseFloat(well.address.longitude)
            };

            bounds.extend(position);

            // Armazenar dados do marcador para criar depois que o mapa estiver pronto
            markers.push({
              position: position,
              well: well,
              index: index
            });
          }
        });

        // Configurar o mapa
        // eslint-disable-next-line no-undef
        this.map = new google.maps.Map(mapElement, {
          zoom: 10,
          center: bounds.getCenter(),
          // eslint-disable-next-line no-undef
          mapTypeId: google.maps.MapTypeId.ROADMAP,
          styles: [
            {
              featureType: 'poi',
              elementType: 'labels',
              stylers: [{ visibility: 'off' }]
            }
          ]
        });

        // Criar os marcadores agora que o mapa está pronto
        const actualMarkers = [];
        markers.forEach(markerData => {
          // Criar marcador personalizado
          // eslint-disable-next-line no-undef
          const marker = new google.maps.Marker({
            position: markerData.position,
            map: this.map,
            title: markerData.well.category.name,
            icon: {
              url: this.getMarkerIcon(markerData.well.category.color),
              // eslint-disable-next-line no-undef
              scaledSize: new google.maps.Size(48, 48),
              // eslint-disable-next-line no-undef
              anchor: new google.maps.Point(24, 48)
            },
            // eslint-disable-next-line no-undef
            animation: google.maps.Animation.DROP,
            optimized: false
          });

          // Criar info window
          // eslint-disable-next-line no-undef
          const infoWindow = new google.maps.InfoWindow({
            content: this.createInfoWindowContent(markerData.well)
          });

          // Adicionar evento de clique
          marker.addListener('click', () => {
            infoWindow.open(this.map, marker);
            this.showDetail(markerData.well);
          });

          actualMarkers.push(marker);
        });

        // Ajustar zoom para mostrar todos os marcadores
        if (actualMarkers.length > 1) {
          this.map.fitBounds(bounds);
        } else if (actualMarkers.length === 1) {
          this.map.setCenter(actualMarkers[0].getPosition());
          this.map.setZoom(15);
        }
      });
    },

    // Criar ícone personalizado para o marcador
    getMarkerIcon: function(color) {
      const svg = `
        <svg width="48" height="48" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
          <!-- Sombra externa -->
          <circle cx="20" cy="20" r="16" fill="rgba(0,0,0,0.3)" opacity="0.4"/>
          
          <!-- Sombra interna -->
          <circle cx="18" cy="18" r="14" fill="rgba(0,0,0,0.2)" opacity="0.3"/>
          
          <!-- Círculo principal com gradiente -->
          <defs>
            <radialGradient id="grad-${color.replace('#', '')}" cx="50%" cy="30%" r="70%">
              <stop offset="0%" style="stop-color:${color};stop-opacity:1" />
              <stop offset="100%" style="stop-color:${this.darkenColor(color, 20)};stop-opacity:1" />
            </radialGradient>
            <filter id="shadow-${color.replace('#', '')}" x="-50%" y="-50%" width="200%" height="200%">
              <feDropShadow dx="2" dy="2" stdDeviation="3" flood-color="rgba(0,0,0,0.4)"/>
            </filter>
          </defs>
          
          <!-- Círculo principal -->
          <circle cx="18" cy="18" r="14" fill="url(#grad-${color.replace('#', '')})" 
                  stroke="white" stroke-width="3" filter="url(#shadow-${color.replace('#', '')})"/>
          
          <!-- Ícone de gota d'água -->
          <path d="M18 10 L22 18 L18 26 L14 18 Z" fill="white" opacity="0.9"/>
          
          <!-- Brilho no topo -->
          <ellipse cx="18" cy="12" rx="6" ry="3" fill="rgba(255,255,255,0.4)" opacity="0.8"/>
        </svg>
      `;
      return 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg);
    },

    // Função para escurecer uma cor
    darkenColor: function(color, percent) {
      const num = parseInt(color.replace("#", ""), 16);
      const amt = Math.round(2.55 * percent);
      const R = (num >> 16) - amt;
      const G = (num >> 8 & 0x00FF) - amt;
      const B = (num & 0x0000FF) - amt;
      return "#" + (0x1000000 + (R < 255 ? R < 1 ? 0 : R : 255) * 0x10000 +
        (G < 255 ? G < 1 ? 0 : G : 255) * 0x100 +
        (B < 255 ? B < 1 ? 0 : B : 255)).toString(16).slice(1);
    },

    // Criar conteúdo do info window
    createInfoWindowContent: function(well) {
      return `
        <div style="padding: 12px; max-width: 280px; font-family: 'Roboto', sans-serif;">
          <div style="display: flex; align-items: center; margin-bottom: 10px;">
            <div style="width: 12px; height: 12px; background: ${well.category.color}; border-radius: 50%; margin-right: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.2);"></div>
            <h4 style="margin: 0; color: ${well.category.color}; font-size: 14px; font-weight: 600;">
              ${well.category.name}
            </h4>
          </div>
          
          <div style="background: #f5f5f5; padding: 8px; border-radius: 6px; margin-bottom: 8px;">
            <p style="margin: 0 0 4px 0; font-size: 12px; color: #333;">
              <strong>ID:</strong> #${well.id}
            </p>
            <p style="margin: 0; font-size: 12px; color: #333;">
              <strong>Status:</strong> 
              <span style="color: ${well.status.color}; font-weight: 500;">
                ${well.status.name}
              </span>
            </p>
          </div>
          
          <div style="border-left: 3px solid ${well.category.color}; padding-left: 8px;">
            <p style="margin: 0; font-size: 11px; color: #666; line-height: 1.4;">
              ${well.address.address_full}
            </p>
          </div>
        </div>
      `;
    },

    // Método para agrupar poços por cidade
    groupWellsByCity: function(wells) {
      try {
        if (!wells || !Array.isArray(wells)) {
          console.warn('Wells não é um array válido:', wells);
          return {};
        }

        if (wells.length === 0) {
          return {};
        }

        // Agrupar por cidade
        const cityGroups = {};
        
        wells.forEach((well, index) => {
          try {
            // Validar se o poço tem a estrutura esperada
            if (!well || typeof well !== 'object') {
              console.warn(`Poço ${index} inválido:`, well);
              return;
            }

            // Extrair cidade e estado do endereço
            let cityName = 'Cidade não informada';
            let state = 'Estado não informado';
            
            if (well.address && well.address.city) {
              cityName = well.address.city.name || 'Cidade não informada';
              state = well.address.city.state ? well.address.city.state.name : 'Estado não informado';
            }

            // Criar chave única para a cidade
            const cityKey = `${state}-${cityName}`.toLowerCase().replace(/\s+/g, '-');
            
            if (!cityGroups[cityKey]) {
              cityGroups[cityKey] = {
                cityKey: cityKey,
                cityName: cityName,
                state: state,
                wells: []
              };
            }
            
            cityGroups[cityKey].wells.push(well);
          } catch (error) {
            console.error(`Erro ao processar poço ${index}:`, error, well);
          }
        });

        // Ordenar os poços dentro de cada cidade por ID
        Object.keys(cityGroups).forEach(key => {
          try {
            cityGroups[key].wells.sort((a, b) => {
              return (a.id || 0) - (b.id || 0);
            });
          } catch (error) {
            console.error(`Erro ao ordenar poços da cidade ${key}:`, error);
          }
        });

        // Ordenar os grupos por estado e cidade
        const sortedGroups = {};
        try {
          const sortedKeys = Object.keys(cityGroups).sort((a, b) => {
            try {
              const groupA = cityGroups[a];
              const groupB = cityGroups[b];
              
              // Primeiro por estado
              const stateCompare = groupA.state.localeCompare(groupB.state);
              if (stateCompare !== 0) {
                return stateCompare;
              }
              
              // Depois por cidade
              return groupA.cityName.localeCompare(groupB.cityName);
            } catch (error) {
              console.error('Erro ao comparar chaves de cidade:', a, b, error);
              return 0;
            }
          });
          
          sortedKeys.forEach(key => {
            sortedGroups[key] = cityGroups[key];
          });
        } catch (error) {
          console.error('Erro ao ordenar grupos de cidade:', error);
          return cityGroups;
        }
        
        return sortedGroups;
      } catch (error) {
        console.error('Erro geral no agrupamento por cidade:', error);
        return {};
      }
    }
  },

  computed: {
    config() {
      return this.$store.state.system.login;
    }
  },

  watch: {
    // Observar mudanças na visão para inicializar o mapa
    viewMode(newMode) {
      if (newMode === 'map') {
        this.$nextTick(() => {
          // Aguardar um pouco para garantir que o DOM foi atualizado
          setTimeout(() => {
            // Tentar acessar os dados de wells de diferentes formas
            let wellsData = null;
            
            // Método 1: Tentar acessar via $refs se existir
            if (this.$refs.loaderApi && this.$refs.loaderApi.data) {
              wellsData = this.$refs.loaderApi.data;
            }
            
            // Método 2: Tentar acessar via $children
            if (!wellsData) {
              const loaderApi = this.$children.find(child => child.$options.name === 'LoaderApi');
              if (loaderApi && loaderApi.data) {
                wellsData = loaderApi.data;
              }
            }
            
            // Método 3: Tentar acessar via event bus ou store
            if (!wellsData) {
              console.warn('Não foi possível acessar os dados de wells para o mapa');
              return;
            }
            
            if (wellsData && wellsData.wells) {
              this.initializeMap(wellsData.wells);
            }
          }, 200);
        });
      }
    }
  },
  
  components: {
    LoaderApi,
    WellCard
  },
};
</script>

<style scoped>
/* Estado vazio */
.empty-state {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border-radius: 16px;
  margin: 20px 0;
}

.empty-state .v-icon {
  opacity: 0.7;
}

/* Estado de carregamento */
.loading-state {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 16px;
  margin: 20px 0;
}

/* Timeline Styles para Cidades */
.timeline-container {
  position: relative;
  padding-left: 0;
}

.timeline-city-group {
  position: relative;
  margin-bottom: 40px;
  padding-left: 0;
}

.timeline-city-group:last-child {
  margin-bottom: 0;
}

/* Timeline Label */
.timeline-label {
  position: relative;
  margin-bottom: 24px;
  padding-left: 0;
}

.timeline-label-content {
  display: flex;
  align-items: center;
  background: linear-gradient(135deg, #2e7d32 0%, #1b5e20 100%);
  border-radius: 12px;
  padding: 12px 16px;
  box-shadow: 0 3px 15px rgba(27, 94, 32, 0.4);
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
}

.timeline-label-content::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.1) 50%, transparent 70%);
  transform: translateX(-100%);
  transition: transform 0.6s ease;
}

.timeline-label:hover .timeline-label-content::before {
  transform: translateX(100%);
}

.timeline-label:hover .timeline-label-content {
  transform: translateY(-2px);
  box-shadow: 0 6px 25px rgba(27, 94, 32, 0.5);
}

.timeline-label-icon {
  background: rgba(255, 255, 255, 0.25);
  border-radius: 10px;
  padding: 6px;
  margin-right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.timeline-label:hover .timeline-label-icon {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.05);
}

.timeline-label-text {
  flex-grow: 1;
  color: white;
}

.timeline-city-name {
  font-size: 1.2rem;
  font-weight: 700;
  margin: 0 0 2px 0;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  color: #ffffff;
}

.timeline-label:hover .timeline-city-name {
  transform: translateX(2px);
}

.timeline-state {
  font-size: 0.85rem;
  margin: 0;
  opacity: 0.95;
  font-weight: 600;
  transition: all 0.3s ease;
  color: #c8e6c9;
}

.timeline-label:hover .timeline-state {
  opacity: 1;
  transform: translateX(2px);
}

.timeline-label-count {
  margin-left: 12px;
}

.timeline-count-chip {
  background: rgba(255, 255, 255, 0.2) !important;
  border: 1px solid rgba(255, 255, 255, 0.4) !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  transition: all 0.3s ease !important;
  font-size: 0.75rem !important;
}

.timeline-label:hover .timeline-count-chip {
  background: rgba(255, 255, 255, 0.25) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
  transform: scale(1.05);
}

/* Timeline Line */
.timeline-line {
  position: absolute;
  left: 0;
  top: 50%;
  width: 3px;
  height: 50px;
  background: linear-gradient(180deg, #2e7d32 0%, #c8e6c9 100%);
  border-radius: 2px;
  transform: translateY(-50%);
  box-shadow: 0 2px 6px rgba(27, 94, 32, 0.4);
  transition: all 0.3s ease;
}

.timeline-city-group:last-child .timeline-line {
  height: 25px;
}

.timeline-label:hover + .timeline-line {
  background: linear-gradient(180deg, #1b5e20 0%, #a5d6a7 100%);
  box-shadow: 0 3px 10px rgba(27, 94, 32, 0.5);
}

/* Timeline Wells */
.timeline-wells {
  padding-left: 0;
  position: relative;
}

.timeline-wells::before {
  content: '';
  position: absolute;
  left: 0;
  top: -20px;
  width: 2px;
  height: 20px;
  background: linear-gradient(180deg, #c8e6c9 0%, transparent 100%);
  border-radius: 1px;
}

/* Animações de entrada */
.timeline-city-group {
  animation: slideInFromLeft 0.6s ease-out;
}

.timeline-city-group:nth-child(1) { animation-delay: 0.1s; }
.timeline-city-group:nth-child(2) { animation-delay: 0.2s; }
.timeline-city-group:nth-child(3) { animation-delay: 0.3s; }
.timeline-city-group:nth-child(4) { animation-delay: 0.4s; }
.timeline-city-group:nth-child(5) { animation-delay: 0.5s; }

@keyframes slideInFromLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Container do toggle de visão */
.view-toggle-container {
  display: flex;
  align-items: center;
}

/* Toggle de visão - Design minimalista */
.view-toggle {
  border-radius: 8px !important;
  overflow: hidden;
  border: 1px solid #e0e0e0;
  background: white;
  transition: border-color 0.2s ease;
}

.view-toggle:hover {
  border-color: #1976d2;
}

.view-btn {
  border-radius: 0 !important;
  text-transform: none !important;
  font-weight: 500 !important;
  min-width: 80px !important;
  height: 36px !important;
  padding: 0 12px !important;
  transition: all 0.2s ease !important;
  border: none !important;
  position: relative;
}

.view-btn:first-child {
  border-top-left-radius: 7px !important;
  border-bottom-left-radius: 7px !important;
}

.view-btn:last-child {
  border-top-right-radius: 7px !important;
  border-bottom-right-radius: 7px !important;
}

.view-btn-text {
  font-size: 0.8rem;
  font-weight: 500;
  margin-left: 4px;
}

/* Estado ativo do botão */
.view-btn.v-btn--active {
  background: #1976d2 !important;
  color: white !important;
}

.view-btn.v-btn--active .v-icon {
  color: white !important;
}

/* Estado inativo do botão */
.view-btn:not(.v-btn--active) {
  background: transparent !important;
  color: #666 !important;
}

.view-btn:not(.v-btn--active):hover {
  background: #f5f5f5 !important;
  color: #1976d2 !important;
}

.view-btn:not(.v-btn--active) .v-icon {
  color: #666 !important;
}

.view-btn:not(.v-btn--active):hover .v-icon {
  color: #1976d2 !important;
}

/* Container do mapa */
.map-container {
  margin-top: 20px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.wells-map {
  width: 100%;
  height: 500px;
  border-radius: 12px;
}

/* Responsividade */
@media (max-width: 768px) {
  .timeline-label-content {
    flex-direction: column;
    align-items: flex-start;
    padding: 10px 14px;
  }
  
  .timeline-label-icon {
    margin-right: 0;
    margin-bottom: 8px;
  }
  
  .timeline-label-count {
    margin-left: 0;
    margin-top: 6px;
    align-self: flex-end;
  }
  
  .timeline-city-name {
    font-size: 1.1rem;
  }
  
  .timeline-state {
    font-size: 0.8rem;
  }
  
  .timeline-line {
    display: none;
  }
}

@media (max-width: 600px) {
  .timeline-city-group {
    margin-bottom: 20px;
  }
  
  .timeline-label {
    margin-bottom: 14px;
  }
  
  .timeline-label-content {
    padding: 8px 12px;
  }
  
  .timeline-city-name {
    font-size: 1.0rem;
  }
  
  .timeline-state {
    font-size: 0.75rem;
  }
  
  .timeline-count-chip {
    font-size: 0.7rem !important;
  }
  
  .wells-map {
    height: 400px;
  }
  
  .view-toggle-container {
    align-items: center;
  }
  
  .view-btn {
    min-width: 60px !important;
    height: 32px !important;
    padding: 0 8px !important;
  }
  
  .view-btn-text {
    font-size: 0.75rem;
    margin-left: 2px;
  }
  
  .view-btn .v-icon {
    font-size: 18px !important;
  }
}
</style>